import type { SuggestionListHandle } from "@circle-react-shared/SuggestionMenu/useSuggestionListKeyboard";
import { ReactRenderer } from "@tiptap/react";
import type { ComponentType } from "react";

interface CreateCompassSuggestionRendererOptions {
  extraProps?: Record<string, unknown>;
  targetDocument?: Document;
}

export const createCompassSuggestionRenderer = (
  Component: ComponentType<any>,
  {
    extraProps = {},
    targetDocument = document,
  }: CreateCompassSuggestionRendererOptions = {},
) => {
  let reactRenderer: ReactRenderer<SuggestionListHandle> | null = null;

  return {
    onStart: (props: any) => {
      reactRenderer = new ReactRenderer(Component, {
        props: { ...props, ...extraProps, clientRect: props.clientRect },
        editor: props.editor,
      });
      targetDocument.body.appendChild(reactRenderer.element);
    },
    onUpdate(props: any) {
      reactRenderer?.updateProps({
        ...props,
        ...extraProps,
        clientRect: props.clientRect,
      });
    },
    onKeyDown(props: any) {
      return reactRenderer?.ref?.onKeyDown(props) ?? false;
    },
    onExit() {
      reactRenderer?.element.remove();
      reactRenderer?.destroy();
      reactRenderer = null;
    },
  };
};
